// extracted by mini-css-extract-plugin
export default {"hint":"DKM23IkhnsnDH3ddETru"};